export default [
  {
    path: "/activityPlace/:aid",
    name: "ActivityPlace",
    component: () => import("@/views/ActivityPlace"),
    meta: {
      roles: ["distributor", "customer"],
    },
    children: [
      {
        path: "suitGoods",
        name: "SuitGoods",
        component: () => import("@/views/ActivityPlace/suitGoods"),
        meta: {
          roles: ["distributor", "customer"],
        },
      },
      {
        path: "goodsDetail/:id",
        name: "ActivityPlaceGoodsDetail",
        component: () => import("@/views/GoodsDetail"),
        meta: {
          roles: ["distributor", "customer"],
        },
      },
    ],
  },
];
